export class Eternl {
  constructor(w) {
    this.w = w;
    if (!this.extensionExists()) {
      return null;
    } else {
      return true;
    }
  }

  async extensionExists() {
    if (this.w.cardano && this.w.cardano.eternl) {
      return true;
    } else {
      return false;
    }
  }

  async enable() {
    if (this.extensionExists()) {
      const enableResponse = await this.w.cardano.eternl.enable();
      if (enableResponse) {
        window.eternl = enableResponse;
        return true;
      } else {
        return false;
      }
    }
  }

  async isEnabled() {
    if (this.extensionExists()) {
      const enabled = await this.w.cardano.eternl.isEnabled();
      return enabled;
    }
  }

  async prepare() {
    const isEnabled = await this.isEnabled();
    if (isEnabled) {
      return true;
    } else {
      const enable = await this.enable();
      if (enable) {
        window.eternl = enable;
        return true;
      } else {
        return false;
      }
    }
  }
}
